import React, { Component } from 'react';
import { Table, Row, Button, message, Spin, Select, Alert } from 'antd';
import moment from 'moment';
import { dataDefault, dataColumns } from './data';
import imgSave from "../../saveImg";
import Auth from "../../Auth";
import TableText from "../../TableText";
import compute from "./compute";
import IsLableAuth from "../../IsLableAuth";

const Option = Select.Option;

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().format('YYYY'),
            data: [],
            loading: true,
            loadingSave: false,
            print: false,
            dateData: [],
        }
    }

    componentDidMount() {
        this.getDateData(this.state.date);
        let date = Number(this.state.date || "0");
        let dateData = [];
        let len = date - 2018 + 3;
        for (let i = 0; i < len; i++) {
            dateData.push((2018 + i).toString())
        }
        this.setState({ dateData });
    }

    computeNum = (data) => {
        data = compute(data);
        this.setState({
            data
        });

    }

    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    getDateData = (date) => {
        const dataBegin = JSON.stringify(dataDefault);
        let data = JSON.parse(dataBegin);
        fetch(`/_9_9_info?year=${moment(date).format('YYYY')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                data = x.data;
            }
            this.setState({ loading: false });
            this.computeNum(data);
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let data = this.state.data.map(x => ({ ...x, year, }));
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }

        fetch('/add_9_9', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            message.error('保存失败' + JSON.stringify(err));
            console.error(err);
        })
    }

    downloadSG = () => {
        this.setState({ print: true, loading: true }, () => {
            imgSave('table9_7', 1.5, '9.90', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })
        });
    }

    render() {
        const data = this.state.data;
        const totalIndex = [9, 11];
        const width = document.body.offsetWidth - 1950 > 300 ? document.body.offsetWidth - 1950 : 300;
        const columns = [
            {
                title: '-',
                dataIndex: 'name',
                key: 'name',
                fixed: 'left',
                align: "center",
                width,
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'text',
                        name: "name",
                        onChange: this.onChange,
                        totalIndex,
                    };

                    return (
                        <TableText data={{ ...props, }} />
                    )
                }
            },
            ...dataColumns.map(item => {
                return {
                    title: item.title,
                    dataIndex: item.name,
                    key: item.name,
                    align: "center",
                    width: 150,
                    render: (text, record, index) => {
                        let type = item.type;
                        if ([...totalIndex, 10].includes(index)) {
                            type = "number";
                        }
                        if (index > 9 && item.name === 'Total') {
                            type = "-"
                        }
                        const props = {
                            text,
                            index,
                            type,
                            name: item.name,
                            onChange: this.onChange,
                            totalIndex,
                            compared: {
                                title: [item.title],
                                record,
                                sqlName: "_9_9"
                            }
                        };

                        return (
                            <TableText data={{ ...props, }} />
                        )
                    }
                }
            })
        ];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1">
                    <Row className="title" id="table9_7" style={{ width: this.state.print ? 2300 : 'auto' }}>
                        <Row>9.9 Rebate Summary 收入抵减汇总</Row>
                        <Row className="table-month">
                            <Select
                                placeholder="请选择年份"
                                style={{ width: 120 }}
                                value={this.state.date}
                                onChange={(str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            >
                                {this.state.dateData.map((x, i) => {
                                    return (
                                        <Option value={x} key={x}>{x}</Option>
                                    )
                                })}
                            </Select>
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            pagination={false}
                            style={{ width: this.state.print ? 2250 : 'auto' }}
                            scroll={this.state.print ? {} : { x: 2250 }}
                            className="content"
                            rowKey={(record, index) => index}
                        />
                    </Row>
                    <Row className="table-footer-btn">
                        <Alert
                            message={
                                <div>
                                    表格关联
                                        <IsLableAuth auth="read_1" {...this.props} path="/table/1">1.1</IsLableAuth>
                                </div>
                            }
                            type="info"
                            showIcon
                            style={{ display: "inline-block", marginRight: 10 }}
                        />
                        <Auth loading={this.state.loading} auth="edit_9_7">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Auth>
                    </Row>
                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/9.0/9-9/index.js